/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author Malinda
 * 10/21/2019
 *
 */

import React, {useState} from 'react';
import Icon  from '../icon/Icon';
import './Alert.css'

/** functional component for Alert **/
const Alert = ({type, alertTitle, alertMessage, icon}) => {
    // set visible state
    const [isOpen, setOpen] = useState(true);

    // get suitable icon
    const typeCheck = () => {
       switch (type) {
           case "Error": return (  <span className="static-error-svg"> <Icon name="warning-18" /> </span>);
           case "Success": return (  <span className="static-success-svg"> <Icon name="success-18" /> </span>);
           default : return (  <span className="static-success-svg"> <Icon name="success-18" /> </span>);
       }
    };

    const disableCheck = null;

    return (
        <div>
            {isOpen &&
            <div className={`static-pe-alert static-alert-${type}`}>
                <div className="static-alert-content-container">
                    {icon && typeCheck()}
                    <div className={`static-alert-content-`}>
                        <h2 className="pe-label static-alert-title">
                            <strong>{alertTitle}</strong>
                        </h2>
                        <p className="pe-paragraph static-alert-text">
                            {alertMessage}
                        </p>
                    </div>
                </div>

                <button className="pe-icon--btn static-close-title"
                        disabled={disableCheck}
                        onClick={() => setOpen(false)}
                        aria-label="Close alert">
                    <Icon name="remove-sm-24"/>
                </button>
            </div>
            }
        </div>
    )
};

export default Alert;
